import React from "react";
import NFLookupEmptyForms from "../../../Shared/NewForms/NFLookupEmptyForms";

function DriverGenericSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default DriverGenericSkeleton;
